module.exports = __webpack_public_path__ + "/public/images/fcd9e6233a654fc4326dbc4227cf5047.png";